import styled from 'styled-components';
import { colors } from 'utils/colors';

export const BoxInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: ${colors.cinza30};
  margin-top: 16px;
`;
